/**
 * Retrieves the current session ID from sessionStorage, or generates a new one if it doesn't exist.
 *
 * The session ID uniquely identifies the user's session within a single browser tab.
 * It persists for the duration of the session (until the tab is closed) and is useful
 * for tracking events tied to a specific session, such as analytics or user behavior tools.
 *
 * @returns {string} A UUID representing the current session ID.
 */
export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};
